import { BaseDataService } from "../../../services/base/BaseDataService";
import { DocTemplateFolderType } from "../models/DocTemplateFolderType";
import { DocTemplateFolderTypeQuery } from "../models/DocTemplateFolderTypeQuery";

export class DocTemplateFolderTypeService extends BaseDataService<
  DocTemplateFolderType,
  DocTemplateFolderTypeQuery
> {
  protected prefixUrl = `DocTemplateFolderTypes`;
}